<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Create Vehicle Scenario</h1>
</div>
<mat-stepper labelPosition="bottom" linear="true" class="stepper" #stepper>
  <mat-step [completed]="firstForm.form.valid">
    <ng-template matStepLabel>Enter Information</ng-template>
    <mat-slide-toggle class="pt-3 pb-3"
                      color="primary" [(ngModel)]="isTvp"
                      labelPosition="before"
                      *ngIf="stateService.hasAuthority(VIEW_AUTHORITY.regionalAdminAuthority)"
                      (toggleChange)="onTvpChange()" ngDefaultControl><h3>Is TVP Scenario</h3>
    </mat-slide-toggle>
    <form #firstForm="ngForm">

      <div class="equal-flex-container">
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label>Scenario Name</mat-label>
            <input matInput #scenarioNameInput name="scenarioName" required [maxlength]="scenarioNameMaxLength"
                   [(ngModel)]="scenarioName">
            <mat-hint align="start">{{ scenarioNameInput.value.length }}/{{ scenarioNameMaxLength }}
              Characters</mat-hint>
          </mat-form-field>
        </span>
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label *ngIf="!isTvp">Scenario Category</mat-label>
            <mat-label *ngIf="isTvp">Forecast Gate</mat-label>
            <mat-select name="scenCat" required [(ngModel)]="scenCat">
              <mat-option *ngFor="let category of scenCatList" [value]="category">{{ category }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label *ngIf="!isTvp">Scenario Type</mat-label>
            <mat-label *ngIf="isTvp">Forecast Type</mat-label>
            <mat-select name="scenType" required [(ngModel)]="scenType">
              <mat-option *ngFor="let type of scenTypeList" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>

      <mat-form-field>
        <mat-label>Scenario Assumption</mat-label>
        <input matInput #assmInput name="assm" required [maxLength]="assmMaxLength" [(ngModel)]="assm">
        <mat-hint align="start">{{ assmInput.value.length }}/{{ assmMaxLength }} Characters</mat-hint>
      </mat-form-field>

      <div class="equal-flex-container">
        <span class="equal-flex-item">
          <mat-form-field *ngIf="isTvp">
            <mat-label>Propulsion Type</mat-label>
            <mat-select name="propType" required [(ngModel)]="propulsionType">
              <mat-option *ngFor="let type of propTypeList" [value]="type">{{ type.propulsionType }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span class="equal-flex-item">
          <mat-form-field *ngIf="isTvp">
            <mat-label>Engineering Program Class</mat-label>
            <mat-select name="engProgClass" required [(ngModel)]="engProgClass">
              <mat-option *ngFor="let element of engProgClassList"
                          [value]="element">{{ element.engProgClass }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span class="equal-flex-item">
          <mat-form-field *ngIf="isTvp">
            <mat-label>Forecast State</mat-label>
            <mat-select name="fcState" required [(ngModel)]="forecastState">
              <mat-option *ngFor="let state of fcStateList" [value]="state">{{ state.forecastState }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
    </form>
    <div class="footer">
      <button [disabled]="!firstForm.form.valid" matStepperNext mat-flat-button color="primary" class="action-button">
        Next
      </button>
    </div>
  </mat-step>

  <mat-step [completed]=stepTwoComplete>
    <form #secondForm="ngForm">
      <ng-template matStepLabel>Choose Source</ng-template>

      <div class="d-flex justify-content-between">
        <div class="equal-flex-container w-50">

          <div class="d-flex w-50">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Select Source</mat-label>
              <mat-select [(ngModel)]="selectedSource" (selectionChange)="onSourceChange()" name="selectedSource">
                <mat-option *ngFor="let source of sourceList" [value]="source"
                            [disabled]="(isTvp && source.tvp === false)">{{ source.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="selectedSource?.id === 0 && !isTvp" class="d-flex w-50">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label class="asterisk--before">Select by Volume/Market Share</mat-label>
              <mat-select [(ngModel)]="keepSharedVol" (ngModelChange)="updateStepTwoComplete()"
                          name="keepSharedVol">
                <mat-option *ngFor="let option of sharedVolList" [value]="option.id">{{ option.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="d-flex w-50" *ngIf="selectedSource?.id === 1">
            <mat-form-field *ngIf="isTvp" subscriptSizing="dynamic">
              <mat-label>Select Architecture</mat-label>
              <mat-select [(ngModel)]="selectedArchitecture" (ngModelChange)="openProgramList(selectedArchitecture)"
                          name="selectedArchitecture">
                <mat-option *ngFor="let architecture of architectures"
                            [value]="architecture">{{ architecture }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="!isTvp" subscriptSizing="dynamic">
              <mat-label>Select Forecast Org</mat-label>
              <mat-select [(ngModel)]="selectedFcorg" (ngModelChange)="openIndSelectComponent()"
                          name="selectedFcorg">
                <mat-option *ngFor="let fcorg of portfolioFcorgs" [value]="fcorg">{{ fcorg }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <mat-card appearance="outlined" class="justify-content-center">
          <div class="d-flex gap-2 flex-wrap align-items-center p-2">
            <span>
            <span class="fw-bold"> Selected Industry Scenario: </span>
            <span class="fst-italic" *ngIf="selectedIndustryScenario"> {{ selectedIndustryScenario?.id }}
              - {{ selectedIndustryScenario?.industryScenarioName }}</span>
            </span>
            <button mat-flat-button color="primary" [hidden]="!selectedIndustryScenario"
                    (click)="openIndSelectComponent()">
              Change Ind Scen
            </button>
          </div>
        </mat-card>
      </div>

      <ng-template matStepContent>
        <div class="d-flex flex-column table-container gap-8 justify-content-start">
          <div class="h-100" id="table-1" *ngIf="selectedSource?.id ===0">
            <app-vehicle-scenario-select
              *ngIf="!isTvp &&( keepSharedVol === 0 || keepSharedVol === 1)"
              [validFcorgs]="NON_TVP_FCORGS"
              [isMultiSelect]="false"
              (confirmEvent)="onSelectVehicleScenario($event)"></app-vehicle-scenario-select>
            <app-vehicle-scenario-select
              *ngIf="isTvp"
              [validFcorgs]="[GMTVP]"
              [isMultiSelect]="false"
              (confirmEvent)="onSelectVehicleScenario($event)"></app-vehicle-scenario-select>
          </div>

          <div *ngIf="selectedSource?.id === 2">
            <div class="drag-and-drop-container">
              <h4>
                <span class="template-dropzone-label">Please Select File to select worksheets from. </span> (Required
                Format: .xls or .xlsx)
              </h4>
            </div>
            <div (files)="upload($event)" appDrag class="dropzone">
              <div class="text-wrapper">
                <div class="centered">Drag and Drop Files Here</div>
                <p class="centered">or</p>
                <div>
                  <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                                     class="upload centered app-upload-button">
                  </app-upload-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <button mat-stroked-button class="action-button" matStepperPrevious>Back</button>
          <button mat-flat-button class="action-button" matStepperNext color="primary"
                  [disabled]="!stepTwoComplete">Next
          </button>
        </div>
      </ng-template>

    </form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Confirm</ng-template>
    <ng-template matStepContent>
      <mat-action-list class="stepper-list" *ngIf="stepTwoComplete">
        <mat-list-item (click)="updateScenarioName(scenarioName,scenarioNameMaxLength)"
                       (keydown)="updateScenarioName(scenarioName, scenarioNameMaxLength)">
          <span matListItemTitle>Scenario Name
            <mat-icon class="confirm-icons">create</mat-icon>
          </span>
          <span matListItemLine>{{ scenarioName }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous(); stepper.previous();"
                       (keydown)="stepper.previous(); stepper.previous();">
          <span matListItemTitle *ngIf="!isTvp">Scenario Category
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemTitle *ngIf="isTvp">Forecast Gate
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ scenCat }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous(); stepper.previous();"
                       (keydown)="stepper.previous(); stepper.previous();">
          <span matListItemTitle *ngIf="!isTvp">Scenario Type
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemTitle *ngIf="isTvp">Forecast Type
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ scenType }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="updateAssumption(assm,assmMaxLength)" (keydown)="updateAssumption(assm,assmMaxLength)">
          <span matListItemTitle>Assumption
            <mat-icon class="confirm-icons">create</mat-icon>
          </span>
          <span matListItemLine>{{ assm }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
          <span matListItemTitle>Base Scenario Source
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedSource.value }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <div *ngIf="selectedSource?.id === 0">
          <div *ngIf="!isTvp">
            <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
              <span matListItemTitle>With New Scenario
                <mat-icon class="confirm-icons">chevron_left</mat-icon>
              </span>
              <span matListItemLine>{{ sharedVolList[keepSharedVol].value }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
          </div>
          <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Selected Vehicle Scenario
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ selectedScenario.vehScenName }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf="isTvp">
          <mat-list-item (click)="stepper.previous(); stepper.previous();"
                         (keydown)="stepper.previous(); stepper.previous();">
            <span matListItemTitle>Propulsion Type
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ propulsionType.propulsionType }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item (click)="stepper.previous(); stepper.previous();"
                         (keydown)="stepper.previous(); stepper.previous();">
            <span matListItemTitle>Engineering Class
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ engProgClass.engProgClass }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item (click)="stepper.previous(); stepper.previous();"
                         (keydown)="stepper.previous(); stepper.previous();">
            <span matListItemTitle>Forecast State
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ forecastState.forecastState }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf="selectedSource?.id === 1">
          <div *ngIf="!isTvp">
            <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Portfolio
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
              <span matListItemLine>{{ selectedFcorg }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
          </div>
          <div *ngIf="isTvp">
            <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
              <span matListItemTitle>Vehicle Programs</span>
              <span matListItemLine *ngFor="let program of selectedVehiclePrograms">{{ program.mktDiv }}
                | {{ program.brand }} | {{ program.prgmCode }} | {{ program.styleCode }}
                | {{ program.bodyStyle }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
          </div>
        </div>
        <div *ngIf="selectedSource?.id === 2">
          <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Sheet Name
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ selectedSheet }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
          <span matListItemTitle>Selected Industry Scenario
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedIndustryScenario?.industryScenarioName }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-action-list>
      <div class="footer">
        <button mat-stroked-button matStepperPrevious class="action-button">Back</button>
        <button mat-flat-button color="primary" matStepperNext class="action-button" (click)="createScenario()">Create
        </button>
      </div>

    </ng-template>
  </mat-step>
</mat-stepper>
